import { z } from 'zod';
import type { Opportunity } from '@axiom/validation';
import { Api } from '@axiom/ui';
import { ZodArrayToEnum } from '@axiom/types';

import { EnvUtil } from '../utils/env-util';

export type readUserOpportunityResponseType = {
  data: Opportunity[];
  meta: {
    currentPage: number;
    pageCount: number;
    resultCount: number;
    aggregations: number | null;
  };
};

export const WorkspaceTypes = {
  accountManagerOwnerOrSalesLead: 'Owned by me',
  collaborator: 'Collaborating on',
};

const WorkspaceTypeValues = Object.keys(WorkspaceTypes) as Array<
  keyof typeof WorkspaceTypes
>;

export const WorkspaceFilters = z.object({
  stage: z.array(z.string()),
  type: z.enum(ZodArrayToEnum(WorkspaceTypeValues)),
  sort: z.string().nullish(),
  order: z.string().nullish(),
  isFulfillmentActive: z.boolean().nullish(),
});

export type WorkspaceFilterType = z.infer<typeof WorkspaceFilters>;

class UserOpportunityApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  readUserOpportunities(
    ownerUserId: string,
    page: number,
    { type, sort, stage, order, isFulfillmentActive }: WorkspaceFilterType
  ) {
    const workspaceTypeKeys = Object.keys(WorkspaceTypes) as Array<
      keyof typeof WorkspaceTypes
    >;
    const filterOwnerType = workspaceTypeKeys.find(workspaceType => {
      return WorkspaceTypes[workspaceType] === type;
    });
    return super.read<readUserOpportunityResponseType>({
      endpoint: `/users/${ownerUserId}/opportunities/search`,
      method: 'POST',
      body: {
        page,
        filters: {},
        isFulfillmentActive,
        order,
        sort,
        assigneeType: filterOwnerType,
        stageCode: stage,
      },
      encodeQuery: false,
    });
  }

  clearReadUserOpportunities(userId: string) {
    super.clear(`/users/${userId}/opportunities/search`);
  }
}

export const UserOpportunityApi = new UserOpportunityApiClass();
